<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">To Roz, Madeline and Marty—the Greenbergs of Green Bay—with fondness, gratitude and love</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?a8c95b3e